<template>
  <div class="curva-s-tab">
    <!-- Tabela Financeiro -->
    <div v-if="viewMode === 'tabela'" class="table-container">
      <h3 class="table-title">Financeiro</h3>
      <div class="table-wrapper">
        <table class="curva-s-table">
          <thead>
            <tr>
              <th class="fixed-column"></th>
              <th v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ bm.nome }}
              </th>
              <th class="fixed-column-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-previsto-parcial">
              <td class="fixed-column row-label">Previsto (Parcial)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatCurrency(bm.previstoP) }}
              </td>
              <td class="fixed-column-right total-cell">
                {{ formatCurrency(totalPrevistoP) }}
              </td>
            </tr>
            <tr class="row-realizado-parcial">
              <td class="fixed-column row-label">Realizado (Parcial)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatCurrencyNullable(bm.realizadoP) }}
              </td>
              <td class="fixed-column-right total-cell">
                {{ formatCurrency(totalRealizadoP) }}
              </td>
            </tr>
            <tr class="row-previsto-acumulado">
              <td class="fixed-column row-label">Previsto (Acumulado)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatCurrency(bm.previstoA) }}
              </td>
              <td class="fixed-column-right total-cell">
              </td>
            </tr>
            <tr class="row-realizado-acumulado">
              <td class="fixed-column row-label">Realizado (Acumulado)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatCurrencyNullable(bm.realizadoA) }}
              </td>
              <td class="fixed-column-right total-cell">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Tabela Percentual -->
    <div v-if="viewMode === 'tabela'" class="table-container">
      <h3 class="table-title">Percentual</h3>
      <div class="table-wrapper">
        <table class="curva-s-table">
          <thead>
            <tr>
              <th class="fixed-column"></th>
              <th v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ bm.nome }}
              </th>
              <th class="fixed-column-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-previsto-parcial">
              <td class="fixed-column row-label">Previsto (Parcial)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatPercentage(bm.previstoPPerc) }}
              </td>
              <td class="fixed-column-right total-cell">
                {{ formatPercentage(totalPrevistoPPerc) }}
              </td>
            </tr>
            <tr class="row-realizado-parcial">
              <td class="fixed-column row-label">Realizado (Parcial)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatPercentageNullable(bm.realizadoPPerc) }}
              </td>
              <td class="fixed-column-right total-cell">
                {{ formatPercentage(totalRealizadoPPerc) }}
              </td>
            </tr>
            <tr class="row-previsto-acumulado">
              <td class="fixed-column row-label">Previsto (Acumulado)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatPercentage(bm.previstoAPerc) }}
              </td>
              <td class="fixed-column-right total-cell"></td>
            </tr>
            <tr class="row-realizado-acumulado">
              <td class="fixed-column row-label">Realizado (Acumulado)</td>
              <td v-for="bm in boletinsMedicao" :key="bm.numero" class="scrollable-column">
                {{ formatPercentageNullable(bm.realizadoAPerc) }}
              </td>
              <td class="fixed-column-right total-cell"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Gráfico Curva S - sempre renderizado mas oculto quando não estiver em modo tabela -->
    <div :style="{ visibility: viewMode === 'tabela' ? 'visible' : 'hidden', height: viewMode === 'tabela' ? 'auto' : '0', overflow: 'hidden' }">
      <curva-s-grafico
        :boletins-medicao="boletinsMedicao"
        ref="curvaSGrafico"
      />
    </div>

    <!-- Gerador e Visualizador de PDF -->
    <curva-s-gerar-pdf
      v-if="viewMode === 'pdf-viewer'"
      :boletins-medicao="boletinsMedicao"
      :fornecedorLogoUrl="fornecedorLogoUrl"
      :boletim-medicao="boletimMedicao"
      :contrato="contrato"
      :contrato-id="contratoId"
      :grafico-component="$refs.curvaSGrafico"
      :valor-total-todos-boletins="valorTotalTodosBoletins"
      ref="curvaSGerarPdf"
    />

    <!-- Upload de Arquivo Assinado -->
    <curva-s-concluir
      v-if="viewMode === 'upload'"
      :contrato-id="contratoId"
      :boletim-medicao-id="boletimMedicao.boletimMedicaoId"
      :documento-boletim-medicao-id="documentoCurvaSAssinada?.documentoBoletimMedicaoId"
      :boletim-medicao="boletimMedicao"
      :tipo-anexo="tipoAnexoAssinadoAtual"
      ref="curvaSConcluir"
      @arquivo-enviado-sucesso="manterModoUpload"
    />

    <!-- Botões de Ação -->
    <curva-s-acoes-btn
      :view-mode="viewMode"
      :disable-geracao-pdf="!podeGerarPdfParaAssinatura"
      :texto-botao-gerar-pdf="textoBotaoGerarPdfAssinatura"
      :fluxo-interno="false"
      @voltar="voltarPasso"
      @gerar-pdf="gerarPdfParaAssinatura"
      @baixar-pdf="baixarPdf"
      @proxima-etapa="proximaEtapa"
    />
  </div>
</template>

<script>
import CurvaSGrafico from './CurvaSGrafico.vue';
import CurvaSAcoesBtn from './CurvaSAcoesBtn.vue';
import CurvaSGerarPdf from './CurvaSGerarPdf.vue';
import CurvaSConcluir from './CurvaSConcluir.vue';
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos';
import { statusBoletimMedicaoEnum } from '../../../BoletimMedicao';
import { tiposAnexoEnum } from '../../../tiposAnexo';


export default {
  name: 'CurvaSTab',
  components: {
    CurvaSGrafico,
    CurvaSAcoesBtn,
    CurvaSGerarPdf,
    CurvaSConcluir
  },

  props: {
    contratoId: { type: [Number, String], default: 0 },
    boletimMedicao: {
    type: Object,
    default: () => {}
    },
    todosBoletinsMedicoes: {
      type: Array,
      default: () => []
    },
    temPlanejamento: {
      type: Boolean,
      default: false
    },
    contrato: {
      type: Object,
      default: () => ({})
    },
    valorTotalTodosBoletins: {
      type: Number,
      default: 0
    },
    fornecedorLogoUrl: {
        type: String,
        default: null
    }
  },

  data() {
    return {
      boletinsMedicao: [],
      loading: false,
      dadosContrato: null,
      viewMode: 'tabela'
    };
  },
  computed: {
    totalPrevistoP() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.previstoP, 0);
    },
    totalRealizadoP() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.realizadoP, 0);
    },
    totalPrevistoA() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.previstoA, 0);
    },
    totalRealizadoA() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.realizadoA, 0);
    },

    totalPrevistoPPerc() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.previstoPPerc, 0);
    },
    totalRealizadoPPerc() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.realizadoPPerc, 0);
    },
    totalPrevistoAPerc() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.previstoAPerc, 0);
    },
    totalRealizadoAPerc() {
      return this.boletinsMedicao.reduce((sum, bm) => sum + bm.realizadoAPerc, 0);
    },
    podeGerenciarAssinaturaAtual() {
      return (this.$store.getters.isFornecedor
        && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor)
        || (this.$store.getters.isFornecedor
          && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor
          && this.boletimMedicao?.curvaSEditavel)
        || (this.$temAcessoView('FISCAL-TERCEIRO')
          && this.boletimMedicao?.status === statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro);
    },
    tipoAnexoAssinadoAtual() {
      if (this.$store.getters.isFornecedor && this.boletimMedicao?.status === statusBoletimMedicaoEnum.DevolvidoParaReassinarFornecedor) {
        return tiposAnexoEnum.CurvaSAssinadaPeloFornecedor;
      }
      const tipoPorStatus = {
        [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFornecedor]: tiposAnexoEnum.CurvaSAssinadaPeloFornecedor,
        [statusBoletimMedicaoEnum.AprovadoParaColetaAssinaturaFiscalTerceiro]: tiposAnexoEnum.CurvaSAssinadaPeloFiscalTerceiro,
      };

      return tipoPorStatus[this.boletimMedicao?.status] || null;
    },
    podeGerarPdfParaAssinatura() {
      return this.podeGerenciarAssinaturaAtual;
    },
    textoBotaoGerarPdfAssinatura() {
      return 'Gerar PDF para Assinatura';
    },
    nomeAnexoCurvaSAssinado() {
      const tipo = this.tipoAnexoAssinadoAtual;
      if (!tipo) return null;
      const anexo = (this.boletimMedicao?.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo);
      return anexo ? (anexo.nome || 'Arquivo já enviado') : null;
    },
    documentoCurvaSAssinada() {
      const tipo = this.tipoAnexoAssinadoAtual;
      if (!tipo) return null;
      return (this.boletimMedicao?.anexos || []).find(a => a.tipoAnexoBoletimMedicao === tipo) || null;
    }
  },
  watch: {
    boletimMedicao: {
      deep: true,
      handler() {
        if (this.contratoId && this.temPlanejamento) {
          this.carregarDados();
        }
      }
    },
    contratoId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.carregarDados();
        }
      }
    },
    temPlanejamento(newVal) {
      if (!newVal) {
        this.boletinsMedicao = [];
        return;
      }

      if (this.contratoId) {
        this.carregarDados();
      }
    },
    todosBoletinsMedicoes: {
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          if (this.dadosContrato) {
            this.processarDadosBoletins(this.dadosContrato);
          }
        }
      }
    }
  },
  methods: {
    obterNumeroBoletim(valor) {
      if (valor === null || valor === undefined) return null;

      let numero = parseInt(valor);
      if (!isNaN(numero) && numero > 0) return numero;

      const numeroExtraido = String(valor).match(/(\d+)/);
      if (!numeroExtraido || !numeroExtraido[1]) return null;

      numero = parseInt(numeroExtraido[1]);
      return isNaN(numero) || numero <= 0 ? null : numero;
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value || 0);
    },
    formatCurrencyNullable(value) {
      if (value === null || value === undefined) return '-';
      return this.formatCurrency(value);
    },
    formatPercentage(value) {
      return `${(value || 0).toFixed(1).replace('.', ',')}%`;
    },
    formatPercentageNullable(value) {
      if (value === null || value === undefined) return '-';
      return this.formatPercentage(value);
    },
    carregarDados() {
      if (!this.temPlanejamento) {
        this.boletinsMedicao = [];
        return;
      }

      if (!this.contratoId) {
        return;
      }

      this.loading = true;
      BoletimMedicaoServicos.obterPlanejamentoFisicoFinanceiroPorContrato(this.contratoId)
        .then(response => {
            if (response && response.success) {
                const dados = response.data;
                this.dadosContrato = dados;
                this.processarDadosBoletins(dados);
            } else {
                this.$toast.warning('Planejamento Físico-Financeiro não encontrado para este boletim.', 'Atenção');
                this.boletinsMedicao = [];
            }
        })
        .catch(error => {
            this.boletinsMedicao = [];
        })
        .finally(() => {
            this.loading = false;
        });
    },

    processarDadosBoletins(dados) {
      if (!dados || !dados.itens || dados.itens.length === 0) {
        this.boletinsMedicao = [];
        return;
      }

      const numerosBoletins = {};
      const previstoParcialPorBm = {};
      const realizadoParcialPorBm = {};
      const numeroBoletimAtual =
        this.obterNumeroBoletim(this.boletimMedicao && this.boletimMedicao.numero) ||
        this.obterNumeroBoletim(this.boletimMedicao && this.boletimMedicao.nome);
      const deveFiltrarPorBoletimAtual = !!numeroBoletimAtual;

      dados.itens.forEach(item => {
        const medicoes = item.medicoes || [];
        medicoes.forEach(medicao => {
          const numeroBoletim = this.obterNumeroBoletim(medicao.boletim);
          if (!numeroBoletim) return;

          if (!previstoParcialPorBm[numeroBoletim]) {
            previstoParcialPorBm[numeroBoletim] = 0;
          }

          previstoParcialPorBm[numeroBoletim] += (medicao.valorCalculado || 0);
          numerosBoletins[numeroBoletim] = true;
        });
      });

      if (this.todosBoletinsMedicoes && this.todosBoletinsMedicoes.length > 0) {
        this.todosBoletinsMedicoes.forEach(boletim => {
          const numeroBoletim = this.obterNumeroBoletim(boletim.numero);
          if (!numeroBoletim) return;
          if (deveFiltrarPorBoletimAtual && numeroBoletim > numeroBoletimAtual) return;

          realizadoParcialPorBm[numeroBoletim] = (boletim.total || 0);
        });
      }

      const boletinsOrdenados = Object.keys(numerosBoletins)
        .map(numero => parseInt(numero))
        .sort((a, b) => a - b);

      const boletins = [];
      let previstoAcumulado = 0;
      let realizadoAcumulado = 0;
      const valorTotalContrato = dados.valorTotalContrato || 1;

      boletinsOrdenados.forEach(numBM => {
        const boletimFuturo = deveFiltrarPorBoletimAtual && numBM > numeroBoletimAtual;
        const previstoP = previstoParcialPorBm[numBM] || 0;
        const realizadoP = boletimFuturo ? null : (realizadoParcialPorBm[numBM] || 0);

        previstoAcumulado += previstoP;
        if (!boletimFuturo) {
          realizadoAcumulado += realizadoP;
        }

        const previstoPPerc = (previstoP / valorTotalContrato) * 100;
        const realizadoPPerc = boletimFuturo ? null : (realizadoP / valorTotalContrato) * 100;
        const previstoAPerc = (previstoAcumulado / valorTotalContrato) * 100;
        const realizadoAPerc = boletimFuturo ? null : (realizadoAcumulado / valorTotalContrato) * 100;
        const periodoLabel = this.formatarLabelBoletim(numBM);

        boletins.push({
          numero: numBM,
          nome: `BM-${String(numBM).padStart(2, '0')}`,
          label: periodoLabel,
          previstoP: previstoP,
          realizadoP: realizadoP,
          previstoA: previstoAcumulado,
          realizadoA: boletimFuturo ? null : realizadoAcumulado,
          previstoPPerc: previstoPPerc,
          realizadoPPerc: realizadoPPerc,
          previstoAPerc: previstoAPerc,
          realizadoAPerc: realizadoAPerc
        });
      });

      this.boletinsMedicao = boletins;
    },

    formatarLabelBoletim(numeroBM) {
      const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
      if (this.todosBoletinsMedicoes && this.todosBoletinsMedicoes.length > 0) {
        const boletimEncontrado = this.todosBoletinsMedicoes.find(bm => {
          return this.obterNumeroBoletim(bm.numero) === numeroBM;
        });


        if (boletimEncontrado && boletimEncontrado.competencia) {
          const dataCompetencia = new Date(boletimEncontrado.competencia);
          const mes = dataCompetencia.getMonth();
          const ano = dataCompetencia.getFullYear();

          const label = `BM${String(numeroBM).padStart(2, '0')}-${meses[mes]}/${String(ano).slice(-2)}`;
          return label;
        }
      }

      return `BM${String(numeroBM).padStart(2, '0')}`;
    },

    voltarPasso() {
      if (this.viewMode === 'upload') {
        this.viewMode = 'pdf-viewer';
      } else if (this.viewMode === 'pdf-viewer') {
        this.viewMode = 'tabela';
      } else {
        this.$emit('voltar');
      }
    },

    gerarPdfParaAssinatura() {
      if (!this.podeGerarPdfParaAssinatura) {
        return;
      }

      if (this.nomeAnexoCurvaSAssinado) {
        this.viewMode = 'upload';
        return;
      }

      this.viewMode = 'pdf-viewer';
    },

    baixarPdf() {
      if (this.$refs.curvaSGerarPdf) {
        this.$refs.curvaSGerarPdf.baixarPdf();
      }
    },

    proximaEtapa() {
      this.viewMode = 'upload';
    },

    manterModoUpload() {
      this.viewMode = 'upload';
      this.$emit('recarregarDadosBoletim');
      this.carregarDados();
    }
},

  mounted() {
    if (this.podeGerenciarAssinaturaAtual && this.nomeAnexoCurvaSAssinado) {
      this.viewMode = 'upload';
    }
  },
};
</script>

<style scoped>
.curva-s-tab {
  padding: 20px;
}

.table-container {
  margin-bottom: 40px;
}

.table-title {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
  color: #626568;
}

.table-wrapper {
  position: relative;
  overflow-x: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.curva-s-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: white;
}

.curva-s-table thead th {
  background-color: #e0e0e0;
  padding: 8px 12px;
  text-align: left;
  font-weight: bold;
  border-bottom: 2px solid #bbb;
  border-right: 1px solid #ccc;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 2;
}

.curva-s-table tbody td {
  padding: 6px 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ccc;
  white-space: nowrap;
  color: #626568;
  font-size: 12px;
  font-weight: 600;
}

/* Fixed first column */
.fixed-column {
  position: sticky;
  left: 0;
  z-index: 3;
  background-color: inherit;
  font-weight: 600;
  text-align: left !important;
  min-width: 200px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  color: #626568;
}

.curva-s-table thead th.fixed-column {
  background-color: #e0e0e0;
  z-index: 4;
  color: inherit;
}

/* Fixed last column (Total) */
.fixed-column-right {
  position: sticky;
  right: 0;
  z-index: 3;
  background-color: #dddddd !important;
  font-weight: 600;
  min-width: 150px;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  color: #626568;
  border-right: none;
}

.curva-s-table thead th.fixed-column-right {
  background-color: #e0e0e0 !important;
  z-index: 4;
  color: inherit;
  border-right: none;
}

/* Scrollable columns */
.scrollable-column {
  min-width: 150px;
}

/* Row colors - alternating pattern */
.row-previsto-parcial td {
  background-color: #9dd5e9;
}

.row-realizado-parcial td {
  background-color: #ffd3df;
}

.row-previsto-acumulado td {
  background-color: #9dd5e9;
}

.row-realizado-acumulado td {
  background-color: #ffd3df;
}

/* Total column cells - override row colors */
.total-cell {
  background-color: #dddddd !important;
}

/* Fixed column in rows - keep row color */
.row-previsto-parcial td.fixed-column {
  background-color: #9dd5e9;
}

.row-realizado-parcial td.fixed-column {
  background-color: #ffd3df;
}

.row-previsto-acumulado td.fixed-column {
  background-color: #9dd5e9;
}

.row-realizado-acumulado td.fixed-column {
  background-color: #ffd3df;
}

/* Hover effect */
.curva-s-table tbody tr:hover td:not(.total-cell):not(.fixed-column) {
  filter: brightness(0.95);
}

/* Row label styling */
.row-label {
  padding-left: 15px;
}
</style>

